import { Component, OnInit } from '@angular/core';
import { StoreService } from './../../../../services/store.service';
import { ApiService } from './../../../../services/api.service';
import { Profil } from './../../../../models/Profil';
import { CommandeService } from './../../../../services/commande.service';
import { SelectItem, Message, ConfirmationService, UIChart } from 'primeng/primeng';
import { CommandeBordereau } from 'src/app/models/CommandeBordereau';
import { CommandeDetail } from 'src/app/models/CommandeDetail';
import { Commande } from 'src/app/models/Commande';
import { ThrowStmt } from '@angular/compiler';
import { DatePipe } from '@angular/common';
import { LocaliteService } from 'src/app/services/reporting/localites.service';
import { ClientsService } from 'src/app/services/reporting/clients.service';
import { ReportingVenteService } from 'src/app/services/reporting/reporting.vente.service';
import { CriteriaData } from 'src/app/models/CriteriaData';
import { ExcelService } from 'src/app/services/Excel.service';

@Component({
  selector: 'app-commande-global',
  templateUrl: './commande-global.component.html',
  styleUrls: ['./commande-global.component.css']
})
export class CommandeGlobalComponent implements OnInit {

  titre = 'Commandes Reelles - Global TELCO';
  itemId: any;
  msgs: Message[] = [];

  fr = {
    firstDayOfWeek: 0,
    monthNames: [
      'Janvier', 'Février', 'Mars',
      'Avril', 'Mai', 'Juin',
      'Juillet', 'Août', 'Septembre',
      'Octobre', 'Novembre', 'Décembre'
    ],
    monthNamesShort: ['Janv.', 'Févr.', 'Mars', 'Avr.', 'Mai', 'Juin', 'Juil.', 'Août', 'Sept.', 'Oct.', 'Nov.', 'Déc.'],
    dayNames: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'],
    dayNamesShort: ['Dim.', 'Lun.', 'Mar.', 'Mer.', 'Jeu.', 'Ven.', 'Sam.'],
    dayNamesMin: ['D', 'L', 'M', 'M', 'J', 'V', 'S']
  };
  today: any = new Date();

  dataBar: any;
  dataPie: any;

  listMsisdn: SelectItem[] = [];
  listLogin: SelectItem[] = [];
  selectedPdg: string;
  selectedMsisdn: string;
  datedebut: any = new Date();
  datefin: any = new Date();

  itemsNafama: any[] = [];
  itemsCarte: any[] = [];
  itemsProduit: any[] = [];
  itemsWallet: any[] = [];
  totalNafama : number = 0;
  totalCarte : number = 0;
  totalProduit : number = 0;
  totalWallet : number = 0;
  montantTotal : number = 0;
  tauxNafama : any ='';
  tauxCarte : any = '';
  tauxWallet : any ='';
  tauxProduit : any ='';
  items: any[] = [];
  displaychargement:boolean;

  constructor(private confirmationService: ConfirmationService,
    private commandeService: CommandeService,
    private datePipe: DatePipe,
    private localiteService: LocaliteService,
    private clientsService: ClientsService,
    private reportingVenteService: ReportingVenteService,
    private excelService: ExcelService,
    private store: StoreService) { }

  ngOnInit() {
    this.loadSelectList();
    this.initChartBarre();
    this.initChartPie();
  }

  async recherche(chartPie: UIChart, chartBarre: UIChart) {

    if(this.selectedPdg === null || this.selectedPdg === undefined || this.selectedPdg === '') {
      //this.msgs = []; this.msgs.push({ severity: 'error', summary: 'Erreur', detail: 'Veuillez selection un PDG ' });
      //return;
    }
    if(this.datedebut === null || this.datedebut === undefined) {
      this.msgs = []; this.msgs.push({ severity: 'error', summary: 'Erreur', detail: 'Veuillez selectionnez une date de debut !' });
      return;
    }
    if(this.datefin === null || this.datefin === undefined) {
      this.msgs = []; this.msgs.push({ severity: 'error', summary: 'Erreur', detail: 'Veuillez selectionnez une date de fin !' });
      return;
    }
    
    this.itemsNafama = [];
    this.itemsCarte = [];
    this.itemsProduit = [];
    this.itemsWallet = [];
    this.totalNafama  = 0;
    this.totalCarte  = 0;
    this.totalProduit  = 0;
    this.totalWallet  = 0;
    this.montantTotal = 0;
    this.tauxNafama  ='';
    this.tauxCarte  = '';
    this.tauxProduit  = '';
    this.tauxWallet  = '';
    this.items = [];

    let criteria: CriteriaData = new CriteriaData();
    criteria.pdg = this.selectedPdg;
    criteria.msisdn = this.selectedMsisdn;
    criteria.datedebut = this.localeDateString(this.datedebut);
    criteria.datefin = this.localeDateString(this.datefin);
    this.displaychargement=true;
    try {
      criteria.nature = "NAFAMA";
      this.itemsNafama = <any>await this.reportingVenteService.commandes(criteria).toPromise();
    } catch (error) {}

    try {
      criteria.nature = "CARTE";
      this.itemsCarte = <any>await this.reportingVenteService.commandes(criteria).toPromise();
    } catch (error) {}

    try {
      criteria.nature = "PRODUIT";
      this.itemsProduit = <any>await this.reportingVenteService.commandes(criteria).toPromise();
    } catch (error) {}

    try {
      this.itemsWallet = <any>await this.reportingVenteService.commandesAchatZebra(criteria).toPromise();
    } catch (error) { }

    this.displaychargement=false;

    if(this.itemsNafama ===null || this.itemsNafama === undefined) {
      this.itemsNafama = [];
    }
    if(this.itemsCarte ===null || this.itemsCarte === undefined) {
      this.itemsCarte = [];
    }
    if(this.itemsProduit ===null || this.itemsProduit === undefined) {
      this.itemsProduit = [];
    }
    if(this.itemsWallet ===null || this.itemsWallet === undefined) {
      this.itemsWallet = [];
    }

    this.itemsNafama.forEach(e => {
      this.totalNafama += (Number(e.quantite) * Number(e.valeurFaciale) );
    });
    this.itemsCarte.forEach(e => {
      this.totalCarte += (Number(e.quantite) * Number(e.valeurFaciale) );
    });
    this.itemsProduit.forEach(e => {
      this.totalProduit += (Number(e.quantite) * Number(e.valeurFaciale) );
    });
    this.itemsWallet.forEach(e => {
      this.totalWallet +=  Number(e.valeur) ;
    });


    this.montantTotal = (+this.totalNafama) + (+this.totalCarte) + (+this.totalProduit) + (+this.totalWallet);
    this.tauxNafama = (this.totalNafama * 100 / this.montantTotal).toFixed(2) + '%';
    this.tauxCarte = (this.totalCarte * 100 / this.montantTotal).toFixed(2) + '%';
    this.tauxProduit = (this.totalProduit * 100 / this.montantTotal).toFixed(2) + '%';
    this.tauxWallet = (this.totalWallet * 100 / this.montantTotal).toFixed(2) + '%';
    
    this.items.push({ 
      carte: this.totalCarte, 
      nafama: this.totalNafama, 
      produit: this.totalProduit, 
      wallet: this.totalWallet, 
      total: this.montantTotal, 
      tauxCarte : this.tauxCarte, 
      tauxNafama:this.tauxNafama, 
      tauxProduit:this.tauxProduit, 
      tauxWallet:this.tauxWallet, 
      pdg: this.selectedPdg
    });

    this.printChartBarre(chartBarre);
    this.printChartPie(chartPie);
  }



  printChartBarre(chart: UIChart) {
    this.dataBar = {
      labels: ['NAFAMA', 'WALLET','CARTE', 'AUTRES PRODUITS', ''],
      datasets: [
          {
              label: 'Commande',
              backgroundColor: '#ff7e33',
              borderColor: '#ff7e33',
              data: [this.totalNafama, this.totalWallet,this.totalCarte,  this.totalProduit, 0]
          }
      ]
    };
    setTimeout(() => {
      chart.ngOnDestroy();
      chart.initChart();
    }, 100);
  }

  printChartPie(chart: UIChart) {
      this.dataPie = {
        labels: ['NAFAMA', 'WALLET','CARTE', 'AUTRES PRODUITS'],
        datasets: [
            {
                data: [this.totalNafama, this.totalWallet, this.totalCarte, this.totalProduit ],
                backgroundColor: [
                  "#00A056",
                  "#FFCE56",
                  "#FE9A2E",
                  "#D473D4"
                ],
                hoverBackgroundColor: [
                  "#00A056",
                  "#FFCE56",
                  "#FE9A2E",
                  "#D473D4"
                ]
            }]
      };
      setTimeout(() => {
        chart.ngOnDestroy();
        chart.initChart();
      }, 100);
    }

  initChartBarre() {
    this.dataBar = {
      labels: ['NAFAMA', 'WALLET','CARTE', 'AUTRES PRODUITS', ''],
      datasets: [
          {
              label: 'Commande',
              backgroundColor: '#ff7e33',
              borderColor: '#ff7e33',
              data: [0, 0, 0, 0, 0]
          }
      ]
    };

  }

  initChartPie() {
      this.dataPie = {
        labels: ['NAFAMA', 'WALLET','CARTE', 'AUTRES PRODUITS'],
        datasets: [
            {
                data: [0, 0, 0, 0],
                backgroundColor: [
                  "#17a2b8",
                  "#00A056",
                  "#FE9A2E",
                  "#D473D4"
                ],
                hoverBackgroundColor: [
                  "#17a2b8",
                  "#00A056",
                  "#FE9A2E",
                  "#D473D4"
                ]
            }]
        };
    }


  
    async loadSelectList() {
      this.listLogin = [];
      if(this.store.isUserPartenaire) {
        this.listLogin.push({ label: this.store.currentNomPDG, value: this.store.currentNomPDG });
        this.selectedPdg = this.store.currentNomPDG;
      } else {
        this.listLogin.push({ label: 'PDG...', value: null });
        try {
          let dataRetourPdg = <any>await this.clientsService.findAgents().toPromise();
          for (let el of dataRetourPdg) {
            this.listLogin.push({ label: el.login, value: el.login });
          }
        } catch (error) { }
      }
  
      this.listMsisdn = [];
      this.listMsisdn.push({ label: 'Msisdn...', value: null });
    }
  
    async onChangePDG(event) {
      this.listMsisdn = [];
      this.listMsisdn.push({ label: 'Msisdn...', value: null });
      let dataRet = <any>await this.clientsService.findByLogin(event).toPromise();
      for (let el of dataRet) {
        this.listMsisdn.push({ label: el.telephone, value: el.telephone });
      }
    }
  
  
    localeDateString(val: any): any {
      if (val === null || val === undefined) {
        return null;
      }
      if (typeof val === 'string') {
        return val;
      } else {
        return this.datePipe.transform(val, "dd/MM/yyyy");
      }
    }

    async exporter() {
      if(this.items === null || this.items === undefined) {
        this.msgs = []; this.msgs.push({ severity: 'error', summary: 'Erreur', detail: 'Aucune données trouvées !' });
        return;
      }
      if(this.items.length <= 0) {
        this.msgs = []; this.msgs.push({ severity: 'error', summary: 'Erreur', detail: 'Aucune données trouvées !' });
        return;
      }
      let listExportXLSX = [];
      listExportXLSX = [...this.items.map(entry => ({
          "PDG": entry.pdg,
          "COMMANDE NAFAMA": entry.nafama,
          "COMMANDE WALLET": entry.wallet,
          "COMMANDE CARTE": entry.carte,
          "COMMANDE AUTRES PRODUITS": entry.produit,
          "TOTAL COMMANDE": entry.total,
          "NAFAMA (%)": entry.tauxNafama,
          "WALLET (%)": entry.tauxWallet,
          "CARTE (%)": entry.tauxCarte,
          "AUTRES PRODUITS (%)": entry.tauxProduit
        }))
      ];
      this.excelService.exportAsExcelFile(listExportXLSX, 'EXPORT');
      this.msgs = []; this.msgs.push({ severity: 'info', summary: 'Confirmation', detail: 'Export effectuée, ' + this.items.length + ' Ligne(s) trouvée(s)' });
    }

}
